import { render, staticRenderFns } from "./PollResults.vue?vue&type=template&id=349c423f&"
import script from "./PollResults.vue?vue&type=script&lang=ts&"
export * from "./PollResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports